<div class="categorization-view document-item-view" id="document-item-view-panel">
  <div class="categorization-type-header">
      {{documentItemMode}}
      <i class="fas fa-info-circle" [title]="documentItemMode ==='component' ? COMPONENT_TOOLTIP_TEXT : VALIDATION_TOOLTIP_TEXT"></i>
  </div>
  <div class="source-item-search">
    <i class="fas fa-search source-item-search-icon" aria-hidden="true"></i>
    <input
      type="text"
      class="source-item-search-input"
      [value]="searchQuery"
      (input)="onSearchInput($any($event.target).value)"
      placeholder="Search line items..."
      aria-label="Search line items"
    />
  </div>
  <div class="display-categorized-toggle">
    <span class="toggle-label">Display Categorized Items</span>
    <i
      class="fas"
      [ngClass]="{'fa-toggle-off': !showCategorizedItems, 'fa-toggle-on': showCategorizedItems}"
      (click)="toggleShowCategorizedItems()"
      role="button"
      tabindex="0"
      (keydown.enter)="toggleShowCategorizedItems()"
      (keydown.space)="toggleShowCategorizedItems(); $event.preventDefault()"
      aria-label="Display Categorized Items"></i>
  </div>
  <div class="source-item-list-wrapper">
    <ul class="source-item-list" *ngIf="filteredDisplayedSourceRows.length > 0" (keydown)="onListKeydown($event)">
      <li
        *ngFor="let sourceRow of filteredDisplayedSourceRows"
        class="source-item-row"
        [class.source-item-row--header]="sourceRow.header">
        <ng-container *ngIf="sourceRow.header">
          <div class="source-item-header-row">
            <span class="source-item-header-label">{{ displayLabel(sourceRow) }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="!sourceRow.header">
          <div class="source-item-label" [class.source-item-row--hover-actions]="isCategorized(sourceRow) && !isSelected(sourceRow)">
            <span
              class="source-item-left"
              [class.source-item-left--display-only]="isCategorized(sourceRow) && !isSelected(sourceRow)"
              (click)="onSourceItemClick(sourceRow)">
              <ng-container *ngIf="isCategorized(sourceRow) && !isSelected(sourceRow); else selectableCheckbox">
                <i class="fa-regular fa-circle-check source-item-check-icon" aria-hidden="true"></i>
              </ng-container>
              <ng-template #selectableCheckbox>
                <input
                  type="checkbox"
                  [checked]="isSelected(sourceRow)"
                  (click)="$event.stopPropagation()"
                  (change)="toggleSelection(sourceRow)"
                />
              </ng-template>
              <span class="source-item-text">{{ displayLabel(sourceRow) }}</span>
            </span>
            <span class="source-item-right" *ngIf="isCategorized(sourceRow) && !isSelected(sourceRow)">
              <button
                type="button"
                class="reassign-button"
                title="Clear existing categorization and select to categorize to this template item"
                (click)="selectForReassign(sourceRow); $event.stopPropagation()">
                <i class="fas fa-right-left" aria-hidden="true"></i>
              </button>
            </span>
          </div>
        </ng-container>
      </li>
    </ul>
    <p *ngIf="filteredDisplayedSourceRows.length === 0" class="no-items-message">
      {{ debouncedSearchQuery
        ? 'No matching line items.'
        : (showCategorizedItems ? 'No source items available.' : 'No uncategorized source items available.') }}
    </p>
  </div>
  <div class="document-item-actions">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!hasSelection"
      (click)="onCategorizeSelected()">
      {{ primaryActionLabel }}
    </button>
  </div>
</div>
